import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../../Business/Turnero/Turnero.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faIdCard, faMapMarkerAlt, faEnvelope, faPhone, faExternalLinkAlt, faSave, faEdit, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

/**
 * EmpresaABM - Management of Companies for the Logged Admin
 */
const EmpresaABM = ({ ipserv, hideHeader = false, onRefresh }) => {
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [formData, setFormData] = useState({
        EmpresaNombre: '',
        EmpresaCuit: '',
        EmpresaDireccion: '',
        EmpresaLat: '',
        EmpresaLong: '',
        EmpresaEmail: '',
        EmpresaTelefono: '',
        EmpresaLinkedin: '',
        EmpresaDescripcion: ''
    });
    const [subStatus, setSubStatus] = useState(null);

    const loadData = () => {
        setLoading(true);
        // The token is automatically handled by the request utility (Bearer dm_auth_token)
        request.Get(ipserv + 'platform/companies', {}, r => {
            if (r.success) setCompanies(r.data || []);
            setLoading(false);
        }, 'json', () => setLoading(false));
    };

    const loadSubscription = () => {
        request.Get(ipserv + 'platform/subscription-status', {}, r => {
            if (r.success) setSubStatus(r);
        });
    };

    useEffect(() => {
        loadData();
        loadSubscription();
    }, []);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setFormData(item || {
            EmpresaNombre: '',
            EmpresaCuit: '',
            EmpresaDireccion: '',
            EmpresaLat: '',
            EmpresaLong: '',
            EmpresaEmail: '',
            EmpresaTelefono: '',
            EmpresaLinkedin: '',
            EmpresaDescripcion: ''
        });
        setShowModal(true);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(ipserv + 'platform/saveCompany', { ...formData, EmpresaId: currentItem?.EmpresaId }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Empresa guardada correctamente' });
                setShowModal(false);
                loadData();
                if (onRefresh) onRefresh();
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al guardar empresa' });
            }
            setLoading(false);
        }, 'json', () => setLoading(false));
    };

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Mis Empresas</h2>
                    <p className="text-muted small">Administra los datos principales de tus empresas registradas.</p>
                </div>
                <button
                    className={`auth-btn-primary ${(!subStatus || subStatus.isExpired || companies.length >= subStatus.plan.MaxEmpresas) ? 'opacity-50' : ''}`}
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
                    onClick={() => {
                        if (subStatus?.isExpired) {
                            Notify({ type: 'info', text: 'Tu plan ha vencido. Pásate a modo suscripción para seguir creando.' });
                        } else if (subStatus && companies.length >= subStatus.plan.MaxEmpresas) {
                            Notify({ type: 'info', text: `Límite de empresas alcanzado (${subStatus.plan.MaxEmpresas}) para tu plan ${subStatus.plan.PlanNombre}.` });
                        } else {
                            handleOpenModal();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Nueva Empresa
                </button>
            </div>


            <div className="row">
                {loading && companies.length === 0 ? (
                    <div className="col-12 text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : companies.length === 0 ? (
                    <div className="col-12 text-center p-5 text-muted">
                        <div className="turnero-card p-5">
                            <FontAwesomeIcon icon={faBuilding} size="3x" className="mb-3 opacity-20" />
                            <h4>No tienes empresas registradas</h4>
                            <p>Comienza dando de alta tu primera empresa para configurar tus turneros.</p>
                        </div>
                    </div>
                ) : (
                    companies.map(emp => (
                        <div key={emp.EmpresaId} className="col-md-6 col-lg-4 mb-4 animate-in">
                            <div className="turnero-card p-4 h-100 d-flex flex-column border-0 shadow-sm" style={{ background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)', borderRadius: '24px' }}>
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div className="turnero-badge bg-primary">
                                        <FontAwesomeIcon icon={faIdCard} className="mr-2" />
                                        {emp.EmpresaCuit}
                                    </div>
                                    <button className="btn btn-sm btn-light shadow-sm rounded-circle p-2" onClick={() => handleOpenModal(emp)} style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <FontAwesomeIcon icon={faEdit} className="text-primary" />
                                    </button>
                                </div>
                                
                                <h3 style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.5rem', marginBottom: '0.5rem' }}>{emp.EmpresaNombre}</h3>
                                <p className="text-muted small flex-grow-1" style={{ lineHeight: '1.6' }}>
                                    {emp.EmpresaDescripcion || 'Sin descripción detallada de la empresa.'}
                                </p>

                                <div className="mt-4 pt-4 border-top border-light">
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="mr-3 bg-primary bg-opacity-10 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', background: 'rgba(0, 97, 255, 0.08)' }}>
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className="text-primary x-small" style={{ fontSize: '0.8rem' }} />
                                        </div>
                                        <span className="small text-muted">{emp.EmpresaDireccion}</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="mr-3 bg-info bg-opacity-10 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', background: 'rgba(0, 210, 255, 0.08)' }}>
                                            <FontAwesomeIcon icon={faEnvelope} className="text-info x-small" style={{ fontSize: '0.8rem' }} />
                                        </div>
                                        <span className="small text-muted">{emp.EmpresaEmail}</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <div className="mr-3 bg-success bg-opacity-10 rounded-circle p-2 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px', background: 'rgba(16, 185, 129, 0.08)' }}>
                                            <FontAwesomeIcon icon={faPhone} className="text-success x-small" style={{ fontSize: '0.8rem' }} />
                                        </div>
                                        <span className="small text-muted">{emp.EmpresaTelefono}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" contentClassName="turnero-card border-0">
                <form onSubmit={handleSave}>
                    <Modal.Body className=" px-4 py-4">
                        <h4 className="mb-4">{currentItem ? 'Editar Empresa' : 'Registrar Nueva Empresa'}</h4>

                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faBuilding} /> Datos Principales
                        </div>
                        <Row>
                            <Col md={8} className="mb-3">
                                <label className="small text-muted mb-1">Nombre de la Empresa</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    value={formData.EmpresaNombre}
                                    onChange={e => setFormData({ ...formData, EmpresaNombre: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={4} className="mb-3">
                                <label className="small text-muted mb-1">CUIT</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    value={formData.EmpresaCuit}
                                    onChange={e => setFormData({ ...formData, EmpresaCuit: e.target.value })}
                                    required
                                />
                            </Col>
                        </Row>

                        <div className="turnero-separator"></div>

                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faMapMarkerAlt} /> Ubicación y Mapa
                        </div>
                        <Row>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Dirección Completa</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    value={formData.EmpresaDireccion}
                                    onChange={e => setFormData({ ...formData, EmpresaDireccion: e.target.value })}
                                    required
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Latitud (G-Maps)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="-34.6037"
                                    value={formData.EmpresaLat}
                                    onChange={e => setFormData({ ...formData, EmpresaLat: e.target.value })}
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Longitud (G-Maps)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="-58.3816"
                                    value={formData.EmpresaLong}
                                    onChange={e => setFormData({ ...formData, EmpresaLong: e.target.value })}
                                />
                            </Col>
                        </Row>
                        {/* Placeholder for Visual Map Picker */}
                        <div className=" rounded p-3 mb-3 text-center border border-secondary" style={{ height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#0f172a' }}>
                            <div>
                                <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" className="text-danger mb-2" />
                                <div className="small text-muted">AQUÍ SE INTEGRARÁ EL PICKER VISUAL</div>
                                <div className="x-small text-muted mt-1">Haga click en el mapa para marcar la ubicación exacta de su sede central.</div>
                            </div>
                        </div>

                        <div className="turnero-separator"></div>

                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faEnvelope} /> Contacto y Adicionales
                        </div>
                        <Row>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Mail de Contacto</label>
                                <input
                                    type="email"
                                    className="turnero-input"
                                    value={formData.EmpresaEmail}
                                    onChange={e => setFormData({ ...formData, EmpresaEmail: e.target.value })}
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Teléfono</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    value={formData.EmpresaTelefono}
                                    onChange={e => setFormData({ ...formData, EmpresaTelefono: e.target.value })}
                                />
                            </Col>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">LinkedIn (URL)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="https://linkedin.com/company/..."
                                    value={formData.EmpresaLinkedin}
                                    onChange={e => setFormData({ ...formData, EmpresaLinkedin: e.target.value })}
                                />
                            </Col>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">Descripción de la Empresa</label>
                                <textarea
                                    className="turnero-input"
                                    rows="3"
                                    value={formData.EmpresaDescripcion}
                                    onChange={e => setFormData({ ...formData, EmpresaDescripcion: e.target.value })}
                                ></textarea>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="border-0 px-4 pb-4">
                        <button type="button" className="btn btn-link text-muted" onClick={() => setShowModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="turnero-btn turnero-btn-primary px-5" disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : (
                                <><FontAwesomeIcon icon={faSave} className="mr-2" /> {currentItem ? 'Actualizar' : 'Crear Empresa'}</>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};

export default EmpresaABM;
